import { UIText2 } from '@cian/ui-kit';

import * as styles from './Address.css';

export interface IOfferAddressProps {
  title: string;
  searchUrl: string;
  id?: number;
}

export interface IAddressProps {
  address?: IOfferAddressProps[];
}

export function Address({ address }: IAddressProps) {
  if (!address) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {address.map((addressItem, index) => {
        return (
          <a
            key={`address_${index}_${addressItem.id}`}
            href={addressItem.searchUrl}
            className={styles['link']}
            target="_blank"
            rel="noopener noreferrer"
            onClick={event => {
              event.stopPropagation();
            }}
          >
            <UIText2 color="current_color">{addressItem.title}</UIText2>
          </a>
        );
      })}
    </div>
  );
}
